import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    UpdateWasteCodeBody,
    WasteCodeResponse,
    updateWasteCode,
    CreateWasteCodeBody,
    createWasteCode,
    softDeleteWasteCode,
    deleteWasteCode,
} from '../../services/apiSLTP/materials/wasteCodes';

type UseUpdateWasteCodeMutationOptions = MutationOptions<WasteCodeResponse, Error, { wasteCodeId: string; data: UpdateWasteCodeBody }>;
type UseCreateWasteCodeMutationOptions = MutationOptions<WasteCodeResponse, Error, CreateWasteCodeBody>;
type UseSoftDeleteWasteCodeMutationOptions = MutationOptions<WasteCodeResponse, Error, string>;
type UseDeleteWasteCodeMutationOptions = MutationOptions<WasteCodeResponse, Error, string>;

export const useUpdateWasteCodeMutation = (options?: UseUpdateWasteCodeMutationOptions) => {
    const wasteCodeMutation: MutationFunction<WasteCodeResponse, { wasteCodeId: string; data: UpdateWasteCodeBody }> = async ({
        wasteCodeId,
        data,
    }) => {
        try {
            const response: WasteCodeResponse = await updateWasteCode(wasteCodeId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste code update');
        }
    };

    return useMutation(wasteCodeMutation, options);
};

export const useCreateWasteCodeMutation = (options?: UseCreateWasteCodeMutationOptions) => {
    const wasteCodeMutation: MutationFunction<WasteCodeResponse, CreateWasteCodeBody> = async (data) => {
        try {
            const response: WasteCodeResponse = await createWasteCode(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste code creation');
        }
    };

    return useMutation(wasteCodeMutation, options);
};

export const useSoftDeleteWasteCodeMutation = (options?: UseSoftDeleteWasteCodeMutationOptions) => {
    const wasteCodeMutation: MutationFunction<WasteCodeResponse, string> = async (wasteCodeId) => {
        try {
            const response: WasteCodeResponse = await softDeleteWasteCode(wasteCodeId);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste code soft delete');
        }
    };

    return useMutation(wasteCodeMutation, options);
};

export const useDeleteWasteCodeMutation = (options?: UseDeleteWasteCodeMutationOptions) => {
    const wasteCodeMutation: MutationFunction<WasteCodeResponse, string> = async (wasteCodeId) => {
        try {
            const response: WasteCodeResponse = await deleteWasteCode(wasteCodeId);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste code deletion');
        }
    };

    return useMutation(wasteCodeMutation, options);
};
